import classNames from 'classnames';
import { ReactNode, useEffect, useRef } from 'react';
import { useEnv } from 'src/hooks';
import { useSidebarState } from '../../hooks';
import styles from '../Sidebar.module.css';
import { ProdTheme, StagingTheme } from './Themes';

type ThemeType = { children: ReactNode };

const Theme = ({ children }: ThemeType) => {
  const ref = useRef<HTMLDivElement>(null);
  const { isSidebarCollapsed, setIsHover } = useSidebarState();
  const { isProdEnv } = useEnv();

  useEffect(() => {
    const variables = isProdEnv ? ProdTheme : StagingTheme;
    Object.entries(variables).forEach(
      ([prop, value]) => ref.current?.style.setProperty(prop, value),
    );
  }, [isProdEnv]);

  return (
    <div ref={ref} className={styles.sidebarContainer}>
      <div
        onMouseEnter={() => setIsHover(true)}
        onMouseLeave={() => setIsHover(false)}
        className={classNames(styles.sidebar, styles.sidebarDefault, {
          [styles.staging]: !isProdEnv,
          [styles.sidebarCollapsed]: isSidebarCollapsed,
        })}
      >
        {children}
      </div>
    </div>
  );
};

Theme.Prod = ProdTheme;
Theme.Staging = StagingTheme;

export default Theme;
